var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocationTooltipHeader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "inherit",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3c3.864 0 7 3.093 7 6.914 0 1.827-1.091 4.386-2.848 7.21l-.187.298a35.412 35.412 0 01-2.171 3.065l-.244.3C12.837 21.658 12.456 22 12 22c-.506 0-.919-.422-1.794-1.513l-.114-.143a35.975 35.975 0 01-2.057-2.922l-.187-.298C6.091 14.301 5 11.741 5 9.914 5 6.094 8.136 3 12 3zm0 17.28c.157-.168.345-.387.553-.644l.179-.223a34.473 34.473 0 001.966-2.794c1.72-2.713 2.802-5.187 2.802-6.705C17.5 6.926 15.04 4.5 12 4.5S6.5 6.926 6.5 9.914c0 1.467 1.01 3.826 2.63 6.43l.172.275a34.468 34.468 0 001.966 2.794l.179.223.135.166c.11.133.214.253.309.359l.109.12zM12 6.5a3.5 3.5 0 110 7 3.5 3.5 0 010-7zM12 8a2 2 0 100 4 2 2 0 000-4z"
  })));
}

export default SvgLocationTooltipHeader;